import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButton from 'LuxKit/Button/TextButton'
import useGlobalSearchVerticalTabHotels from 'components/SearchV2/Hooks/useGlobalSearchVerticalTabHotels'
import GlobalSearchContextProvider from 'contexts/GlobalSearch/GlobalSearchContextProvider'
import type { GlobalSearchAction } from 'contexts/GlobalSearch/GlobalSearchState'
import type GlobalSearchState from 'contexts/GlobalSearch/GlobalSearchState'
import { GlobalSearchStateActions } from 'contexts/GlobalSearch/GlobalSearchState'
import { useEffect } from 'react'
import * as React from 'react'
import { useLocation } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { getDestinationLandingSearchItem } from './getDestinationLandingSearchItem'

function MobileSearch() {
  const intl = useIntl()
  const { pathname } = useLocation()
  const globalSearchVerticalTabHotels = useGlobalSearchVerticalTabHotels()
  const { context, ContentComponent: SearchElement, onSearch } = globalSearchVerticalTabHotels
  const hotelsSearchDispatch = context.dispatch as React.Dispatch<GlobalSearchAction>

  useEffect(() => {
    const searchItem = getDestinationLandingSearchItem(pathname)
    if (!searchItem) return

    hotelsSearchDispatch({
      type: GlobalSearchStateActions.SET_SEARCH_ITEM,
      searchItem,
    })
  }, [hotelsSearchDispatch, pathname])

  return (
    <GlobalSearchContextProvider state={context.state as GlobalSearchState} dispatch={hotelsSearchDispatch}>
      <VerticalSpacer gap={12}>
        <SearchElement
          onSearch={onSearch}
          isInPage
          temporarySearchSubmitRef={globalSearchVerticalTabHotels.temporarySearchSubmitRef}
          updateSearchSessionId={globalSearchVerticalTabHotels.updateSearchSessionId}
        />
        <TextButton
          kind="primary"
          size="large"
          shape="square"
          fit="full-width"
          onClick={onSearch}
        >
          {intl.formatMessage({
            id: 'lco2GTjHxZKwhxqqXUDM',
            defaultMessage: 'Search',
            description: 'Button text for the search action in the main search form or search bar input',
          })}
        </TextButton>
      </VerticalSpacer>
    </GlobalSearchContextProvider>
  )
}

export default MobileSearch
